import { render, staticRenderFns } from "./AccreditationCreateContainer.vue?vue&type=template&id=192972b8"
import script from "./AccreditationCreateContainer.vue?vue&type=script&lang=js"
export * from "./AccreditationCreateContainer.vue?vue&type=script&lang=js"
import style0 from "./AccreditationCreateContainer.vue?vue&type=style&index=0&id=192972b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports